import { Navigate, Outlet, useLocation, useOutletContext } from "react-router-dom";

import { useUser } from "routes/dataroutes/UserData";

import { setCookie } from "utils/cookieUtils";
import { path as HomePath } from "v2/pages/home/HomeRoute";
import { useAuthenticationVersion } from "providers/AuthenticationProvider";


export function ToLoginIfNotAuthenticated() {
  const { isAuthenticated } = useAuthenticationVersion();
  const user = useUser();
  const outletContext = useOutletContext();
  const location = useLocation();

  if (!isAuthenticated || !user) {
    // saving the current url to redirect to after GitHub login, otherwise we would lose this info during the redirects
    setCookie("sapiTargetUrl", location.pathname, { expires: 1 });

    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  return <Outlet context={outletContext} />;
}

export function ToDashboardIfAlreadyAuthenticated() {
  const { isAuthenticated } = useAuthenticationVersion();
  const user = useUser();
  const outletContext = useOutletContext();
  const location = useLocation();

  if (isAuthenticated && user && !user.email.toLowerCase().endsWith(".inactive")) {
    return <Navigate to={ location.state?.from || HomePath } replace />;
  }

  return <Outlet context={ outletContext } />;
}

export function ToActivationPageIfDeactivated() {
  const { isAuthenticated } = useAuthenticationVersion();
  const user = useUser();
  const outletContext = useOutletContext();

  if (!isAuthenticated || user?.email?.toLowerCase()?.endsWith(".inactive")) {
    return <Navigate to="/login" />;
  }

  if (isAuthenticated && user && !user.apiKey && !user.isBlocked) {
    return <Navigate to="/send-activation-email" />;
  }

  return <Outlet context={ outletContext } />;
}

export function ToPreviousPageIfBlocked() {
  const user = useUser();
  const outletContext = useOutletContext();
  const location = useLocation();

  if (user?.isBlocked) {
    // TODO location.state is not always set, and is mainly used for storing target path names for authentication redirects.
    //  here we should better navigate one step back in history, or to the dashboard if there is no history.
    const locationState = location.state;
    const from = locationState?.from || locationState?.background || locationState?.backgroundLocation || HomePath;

    return <Navigate to={ from } replace />;
  }

  return <Outlet context={ outletContext } />;
}
